<template>
  <div class="entity-detail-header">
    <div class="entity-detail-header__main">
      <v-btn text class="entity-detail-header__back px-0" @click="$emit('back')">
        <v-icon left small>mdi-arrow-left</v-icon>
        {{ backLabel }}
      </v-btn>
      <div class="entity-detail-header__identity">
        <h1 class="entity-detail-header__title">{{ title }}</h1>
        <p v-if="subtitle" class="entity-detail-header__subtitle">{{ subtitle }}</p>
        <div v-if="$slots.badges" class="entity-detail-header__badges">
          <slot name="badges" />
        </div>
      </div>
    </div>
    <div v-if="$slots.actions" class="entity-detail-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityDetailHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    backLabel: { type: String, default: "Voltar" },
  },
});
</script>

<style scoped lang="scss">
.entity-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.entity-detail-header__main {
  flex: 1;
  min-width: 0;
}

.entity-detail-header__back {
  margin-bottom: 8px;
  color: #64748b !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.entity-detail-header__title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f243f;
  line-height: 1.2;
}

.entity-detail-header__subtitle {
  margin: 6px 0 0;
  font-size: 0.95rem;
  color: #64748b;
}

.entity-detail-header__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 12px;
}

.entity-detail-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
}
</style>
